import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc from '../components/product-sticky-atc';
import initProductGallery from '../components/product-gallery';
import initPdpTabs from '../sections/product/pdp-tabs';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initRelatedProducts();
  initProductGallery();
  initPdpTabs();
  initProductStickyAtc();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
  initProductGallery();
  initPdpTabs();
});
